<template>
  <div class="table-group">
    <div class="group-title">零件材料成本</div>
    <vxe-grid
      :min-height="tableConfig.minHeight"
      :toolbar-config="tableConfig.toolbarConfig"
      :edit-config="tableConfig.editConfig"
      :row-config="tableConfig.rowConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="selfList"
      :show-footer="!!selfList.length"
    >
      <!-- slot_default -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image
          v-if="row.list_chan_pin_tu"
          :list.sync="row.list_chan_pin_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_name="{ row }">
        <div class="flex flex-x-between flex-y-center">
          <el-input v-model="row.name" size="mini" class="flex-1" :disabled="disabled" />
        </div>
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image
          :list.sync="row.list_gong_cheng_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" :disabled="disabled" isDelete />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>
      <template #default_do="{ rowIndex }">
        <el-link type="danger" :disabled="disabled" @click="rowDelete(rowIndex)"> 删行 </el-link>
      </template>

      <!-- slot_edit -->
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" type="text" size="mini" @input="inputUpdate('spec', row)" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" type="text" size="mini" @input="inputUpdate('unit', row)" />
      </template>
      <template #edit_counts="{ row }">
        <el-input
          v-model="row.counts"
          type="number"
          size="mini"
          @input="inputUpdate('counts', row)"
        />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input v-model="row.goods_price" type="number" size="mini" @input="onGoodsPriceInput(row)" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" type="text" size="mini" />
      </template>

      <!-- 数据为空 -->
      <template #empty>
        <div class="flex flex-center">
          <span class="c-gray-light">暂无数据</span>
          <el-link v-if="!disabled" class="m-l-10" type="success" @click="rowAdd">增行</el-link>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    mainData: {
      type: Object,
      required: true
    },
    goods_price: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      jin_du_list: ['待采购', '采购中', '已入库'],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 103
        },
        {
          title: '零件图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '零件名称',
          field: 'name',
          slots: { default: 'default_name' },
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' },
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' },
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' },
          width: 120
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ],
      selfList: [],
      singleCount: 1,
      isEditingPrice: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    list: {
      handler(val) {
        if (this.isEditingPrice) return
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        if (this.isEditingPrice) return
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', this.$util.deepCopy(val))
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 行-增行
    rowAdd() {
      let result = this.$util.deepCopy(this.$constant.newTableSaleSubObj)
      result.name = this.mainData.name
      result.spec = this.mainData.spec
      result.counts = this.mainData.counts
      result.unit = this.mainData.unit
      result.goods_price = this.mainData.goods_price
      result.goods_amount = this.mainData.goods_amount
      this.selfList.push(result)
    },
    // 行-删行
    rowDelete(index) {
      this.selfList.splice(index, 1)
      this.$emit('delete')
    },
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    inputUpdate(field, row) {
      let obj = {
        idx: 2,
        key: field,
        val: row[field]
      }
      if (field === 'spec') {
        let counts = this.$tool.getSinglePartCount(this.mainData.spec, row.spec)
        this.singleCount = counts
        row.counts = this.$XEUtils.multiply(this.mainData.counts, counts)
        let goods_price = this.$XEUtils.divide(this.mainData.goods_price, counts)
        row.goods_price = this.$XEUtils.round(goods_price, 4)
        row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
        // 向下游发出 counts 级联
        obj.key = 'counts'
        obj.val = row.counts
      }
      if (field === 'counts') {
        let data = this.$util.deepCopy(this.mainData)
        let result = this.$XEUtils.divide(row.counts, this.singleCount)
        data.counts = this.$XEUtils.ceil(result)
        this.$emit('update:mainData', data)
        // 延迟等待 mainData 更新后重算单价
        setTimeout(() => {
          let goods_price = this.$XEUtils.divide(this.mainData.goods_amount, row.counts)
          row.goods_price = this.$XEUtils.round(goods_price, 4)
          row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
        }, 100)
      }
      this.$emit('fieldUpdate', this.$util.deepCopy(obj))
    },
    // 手动修改零件单价时，重算金额并通知父组件反向更新原材料
    onGoodsPriceInput(row) {
      this.isEditingPrice = true
      row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
      // 计算所有零件的总金额，直接传给父组件避免父组件读取旧数据
      let totalPartsAmount = 0
      this.selfList.forEach((item) => {
        totalPartsAmount = this.$XEUtils.add(totalPartsAmount, Number(item.goods_amount))
      })
      this.$nextTick(() => {
        this.$emit('partPriceChange', { totalPartsAmount })
        this.$nextTick(() => {
          this.isEditingPrice = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
}
</style>
